import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: ${spacing(5)};
  align-items: start;
  width: 100%;

  > * {
    min-width: 0;
  }

  /*
    Tiles are pinned to a column so that a tile which renders null (the
    lifecycle tile, whenever no lifecycle action is available on this card)
    cannot push its siblings ACROSS the gutter. Without this, hiding the first
    tile shifted all three survivors sideways and the bento looked scrambled
    rather than looking like one section was absent.

    This is not full column independence, and does not try to be: grid rows
    still couple heights across the gutter, so a tall tile on the left sets the
    row height and the right column's next tile starts below it. Concretely,
    with the lifecycle tile hidden the rows are (SpendRestrictions | SpendLimit)
    and (— | CardSettings) — and since SpendRestrictions is the tallest tile in
    the bento, Card settings drops below all of it. Each tile keeps its COLUMN;
    vertical position still moves. True independence would need two flex-column
    containers instead of one grid, which makes DOM order column-major — a
    reading-order decision, not a layout tweak. Left alone deliberately.

    No 'grid-auto-flow: dense'. Dense packing would let a later tile fill an
    earlier hole, diverging visual order from DOM order and so from focus order
    (WCAG 2.4.3). The parent instead emits the tiles in the order they end up
    reading, which leaves nothing for dense to backfill.
  */
  > .UpdatedPhysicalCardSettings-colLeft {
    grid-column: 1;
  }

  > .UpdatedPhysicalCardSettings-colRight {
    grid-column: 2;
  }

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);

    > .UpdatedPhysicalCardSettings-colLeft,
    > .UpdatedPhysicalCardSettings-colRight {
      grid-column: auto;
    }
  }
`
